<p-confirmDialog></p-confirmDialog>
<p-toast  position="top-right"></p-toast>

<div class="field-edit-body">
  <div class="field-edit-scroll">
    <p-tabs [(value)]="activeTab">
      <p-tablist>
        <p-tab value="0">{{ "General information" | translate }}</p-tab>
        <p-tab value="1">{{ "Map" | translate }}</p-tab>
      </p-tablist>

      <p-tabpanels>
        <p-tabpanel value="0">
          <div class="form-content">
            <msf-form-builder
              [fields]="fields"
              [(model)]="model"
              flexDirection="row"
            ></msf-form-builder>
          </div>
        </p-tabpanel>

        <p-tabpanel value="1">
          <div
            class="map-wrapper"
            *ngIf="activeTab === '1'">
            <div class="map-controls">
              <app-checkbox
                [(ngModel)]="showCrops"
                [label]="'Show_crops' | translate"
              ></app-checkbox>
              <msf-form-builder
                [fields]="getEditSourceForm()"
                [(model)]="this.formData"
                flexDirection="row"
              ></msf-form-builder>
            </div>

            <mfs-old-map
              [height]="'100%'"
              [zoom]="13"
              [isSplitControl]="canSplit"
              [drawingMode]="!showCrops"
              (markerClick)="onMarkerClick($event)"
              [(geometry)]="config.data.model.polygon"
              [isCenterMarker]="false"
              [showControls]="true"
              [isCenterControl]="false"
              [polygonJson]="showCrops ? null : formData?.polygonJson"
              [multiPolygonJsonColors]="showCrops ? multiPolygonJson : []"
              [splitLabels]="['Old' | translate, 'New'| translate]"
              [(splitPolygons)]="splitPolygons"
            ></mfs-old-map>
          </div>
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>

<div class="actions" [class.actions--embedded-top]="isEmbeddedInShell">
  <p-button
    [severity]="'secondary'"
    label="{{ 'Cancel' | translate }}"
    class="p-button-text button-secondary"
    (click)="cancel()"></p-button>

  <button
    pButton
    type="button"
    label="{{ 'Save' | translate }}"
    class="p-button-primary"
    (click)="save()"
    [loading]="isLoading"></button>
</div>
